export const Faqdata = [
    {
        Question: "Is Profi1 Station a SEBI-registered broker itself??",
        Answer: "No — Profi1 Station operates as an authorized Business Associate of Motilal Oswal Financial Services Ltd. All trades are executed through MOFSL, which holds the relevant SEBI registrations.",

    },
    {
        Question: "How long does account opening take??",
        Answer: "Most accounts are opened same-day through a fully paperless process, subject to document verification.",
    },
    {
        Question:"Do you charge for the initial consultation?",
        Answer:"No — the first consultation is free and carries no obligation to open an account.",
    },
    {
        Question:"Can I meet an advisor in person in Patiala?",
        Answer:"Yes, our Patiala office is open for in-person consultations alongside phone and WhatsApp support.",
    },
]